import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";
@Component({
    selector: "dodo-info-dialog-layout",
    templateUrl: "./info-dialog-layout.component.html",
    styleUrls: ["./info-dialog-layout.component.scss"],
    standalone: false
})
export class InfoDialogLayoutComponent implements OnInit {
	@Input() source = "";
	@Output() close = new EventEmitter();
	constructor() {}
	ngOnInit() {}
}
